import { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import Icon, { ICON_MAP } from '@mindtickle/icon';
import Tooltip from '@mindtickle/tooltip';
import useEchoWidget from '~/components/Echo/hooks/useEchoWidget';
import { IntlType } from '~/components/GlobalHeader/Learner/type';
import messages from './messages';

type TEchoWidgetButtonProps = { isCollapsed: boolean; isAdmin: boolean; intl: IntlType };

const EchoWidgetButton = ({ isCollapsed, isAdmin, intl }: TEchoWidgetButtonProps) => {
  const { isEchoWidgetLoaded, toggleEchoWidget, isEchoWidgetOpen } = useEchoWidget();

  useEffect(() => {
    const echoWidget = document.querySelector('echo-widget');
    if (!echoWidget) return;

    if (isCollapsed) {
      echoWidget.classList.remove('mt-sidebar-expanded');
    } else {
      echoWidget.classList.add('mt-sidebar-expanded');
    }
  }, [isCollapsed, isEchoWidgetLoaded]);

  if (!isEchoWidgetLoaded || !isAdmin) return null;

  if (isEchoWidgetOpen) {
    return (
      <div data-testid="navigation-footer-copilot-btn" className="nav-action-btn-copilot-wrapper">
        <Icon onClick={toggleEchoWidget} type={ICON_MAP.CROSS} className="nav-action-btn" />
      </div>
    );
  }
  return (
    <Tooltip
      placement="right"
      align={{ targetOffset: [12, 0] }}
      getPopupContainer={() => document.body}
      title={intl.formatMessage(messages.CHAT_WITH_SUPPORT)}
    >
      <div data-testid="navigation-footer-freshchat-btn" className="nav-action-btn-copilot-wrapper">
        <Icon
          onClick={toggleEchoWidget}
          type={ICON_MAP.SPARKLE}
          className="nav-action-btn"
          data-testid="echo-widget-toggle-button"
          aria-label={intl.formatMessage(messages.ECHO_TOGGLE_LABEL)}
        />
      </div>
    </Tooltip>
  );
};

export default injectIntl(EchoWidgetButton);
